// extracted by mini-css-extract-plugin
module.exports = {"page404":"not-found_page404__pDWnr"};